<template>
  <div class="course-introduce-container" :class="isMobile?'mobile-course-introduce-container':''">
    <img v-if="!isMobile" class="detail-bg" src="@assets/img/index/course-detail-bg.png" alt="">
    <div v-if="!isLoadCourse && !isMobile" class="course-introduce-inner clear-float">
      <div
          class="collection"
          @click="collectCourse"
      >
        <img v-if="isCollect" src="@assets/img/index/collect-active-icon.png" alt="">
        <img v-else src="@assets/img/index/collect-icon.png" alt="">
        <div>{{ isCollect ? '已收藏' : '收藏' }}</div>
      </div>
      <a-col :span="8">
        <img :src="courseInfo.coverFileUrl" alt="">
      </a-col>
      <a-col :span="14">
        <li>
          <header :title="courseInfo.courseTitle">{{ courseInfo.courseTitle }}</header>
        </li>

        <li><span style="margin-right: 10px"> 累计{{ courseInfo.participationsCount }}人学习</span>
          <a-rate disabled :value="score"/>
        </li>

        <!--免费-->
        <li v-if="isFree">
          <span style="color: #00CF8C">免费</span>
        </li>
        <!--已经购买-->
        <li v-else-if="isPaid">
          <span style="color: #FF8000">已拥有</span>
        </li>
        <!--付费-->
        <li v-else-if="!isFree && !isDiscount">
          <span>￥{{ courseInfo.coursePrice }}</span>
          <img class="vip-free" src="@assets/img/index/vip-free.png" alt="" >
        </li>
        <!--付费打折-->
        <li v-else>
          <span>￥{{ courseInfo.discountPrice }}</span>
          <span>￥{{ courseInfo.coursePrice }}</span>
          <div>
            <a-tag color="orange">{{ courseInfo.discountDesc }}</a-tag>
          </div>
        </li>
        <li style="width: 750px">
          <div v-if="isPaid || isFree ||isMember">
            <a-button class="now-watch" type="primary" @click="canPlayVideo">立即观看</a-button>
            <a-button class="join-shop-car" type="primary" @click="joinShoppingCart">加入购物车</a-button>

            <span class="Learning-progress-bar clear-float" v-if="isLogin">
                            <dt>已学习{{ courseInfo.learnedSectionNum }}/{{ courseInfo.subSectionNum }}课时</dt>
                            <dt><a-progress :percent="courseInfo.learnedSectionNum*100/courseInfo.subSectionNum"
                                            :showInfo="false" strokeColor="#00CF8C" size="small"/></dt>
                        </span>
          </div>
          <div v-else style="text-align: right;margin-top: -20px">
            <a-button class="buy-now-button" type="primary" @click="showModal()">立即购买</a-button>
            <a-button class="join-shop-car" type="primary" @click="joinShoppingCart">加入购物车</a-button>
            <!--            <span class="Learning-progress-bar clear-float" v-if="isLogin">-->
            <!--                            <dt>已学习{{ courseInfo.learnedSectionNum }}/{{ courseInfo.subSectionNum }}课时</dt>-->
            <!--                             <dt><a-progress :percent="courseInfo.learnedSectionNum*100/courseInfo.subSectionNum"-->
            <!--                                             :showInfo="false" strokeColor="#00CF8C" size="small"/></dt>-->
            <!--                        </span>-->
          </div>
        </li>
      </a-col>
    </div>
    <div v-else-if="isLoadCourse">
      <a-skeleton style="padding: 20px" active/>
    </div>
    <!--移动端样式-->
    <div v-else class="mobile-cover">
      <div class="image-content">
        <img :src="courseInfo.coverFileUrl" alt="">
        <div v-if="isMobile " class="mobile-course-desc-container">
          <div class="mobile-course-desc-inner">
            <h4>{{ courseInfo.courseTitle }}</h4>
            <div>
              <a-rate disabled allowHalf :value="score" style="font-size: 12px"/>
              <span class="study-num"> {{ courseInfo.participationsCount }}人学习</span>
            </div>
            <div class="mobile-course-desc-price">
              <div v-if="isFree" style="margin-top: 8px">
                <span style="color:#B7BBC4;">免费</span>
              </div>

              <div v-else-if="isDiscount">
                <div>
                  <span class="current-price">￥{{ courseInfo.discountPrice }}</span>
                  <span
                      style="text-decoration: line-through;color: #B7BBC4;font-size: 14px;margin:0 10px">￥{{
                      courseInfo.coursePrice
                    }}</span>
                </div>
                <div>
                  <a-tag color="orange">{{ courseInfo.discountDesc }}</a-tag>
                </div>
              </div>

              <div v-else>
                <span class="current-price">￥{{ courseInfo.coursePrice }}</span>
                <img src="@assets/img/index/vip-free.png" alt="" style="width:60px;margin:-5px 0 0 5px;">
              </div>

            </div>
          </div>
        </div>
      </div>
      <div v-if="isLogin" style="display: block;font-size: 12px">
        <a-row>
          <a-col :span="17">
            <a-progress
                :percent="courseInfo.learnedSectionNum*100/courseInfo.subSectionNum"
                :showInfo="false" strokeColor="#00CF8C" size="small"/>
          </a-col>
          <a-col :span="7">
            <div style="text-align: right;color: #B7BBC4;font-size: 12px"><span>已学 <span
                style="color: #00B278">{{ courseInfo.learnedSectionNum }}</span>/{{
                courseInfo.subSectionNum
              }}课时</span>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div v-if="isMobile && !isLoadCourse" class="mobile-bottom-action">
      <div class="mobile-bottom-button">
        <div>
          <img v-if="isCollect" src="@assets/img/index/collect-active-icon.png" @click="collectCourse"/>
          <img v-else src="@assets/img/index/collect-icon.png" @click="collectCourse"/>
          <div>{{ isCollect ? '已收藏' : '收藏' }}</div>
        </div>
        <div v-if="!isPaid && !isFree " @click="joinShoppingCart">
          <img src="@assets/img/index/shop-icon-green.png" alt="">
          <div>购物车</div>
        </div>
      </div>
      <div>
        <a-button v-if="isPaid || isFree||isMember" type="primary" @click="canPlayVideo">立即观看</a-button>
        <a-button class="buy-now-button" v-else type="primary" @click="showModal()">
          立即购买
        </a-button>
      </div>
    </div>
    <!--立即付款弹窗-->
    <a-modal v-model="showPayModel"
             title="购买课程"
             cancelText="取消"
             :okText="okText"
             :confirmLoading="confirmLoading"
             @ok="handleOk">
      <div class="modal">
        <p style="margin-bottom: 20px">
          <a-row>
            <a-col :span="9"><img :src=courseInfo.coverFileUrl alt=""></a-col>
            <a-col :span="13" offset="1">{{ courseInfo.courseTitle }}</a-col>
          </a-row>
        </p>
        <p v-if="isDiscount">课程价格：
          <span
              style="text-decoration: line-through;color: #FF4F23;font-size: 14px;margin: 0 10px 0 0">￥{{
              courseInfo.coursePrice
            }}</span>
          <span style="color: #E85A26;font-size: 18px;"
                v-if="courseInfo.isDiscount">￥{{ courseInfo.discountPrice }}</span>
        </p>
        <p v-else>
          课程价格：
          <span style="color: #FF4F23;font-size: 14px;margin: 0 10px 0 0">￥{{ courseInfo.coursePrice }}</span>
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import common from "../../../mixin/common";
import {createOrder} from "@api/shopping-api"
import {showError, showMsg, showSuccessMsg} from "@utils/msg";
import {COURSE_ALREADY_PAID, SUCCESS} from "@constants/code";
import {DISPATCH_ADD_CART} from "@constants/action-type/cart-action-type";
import {createNamespacedHelpers} from "vuex";
import {DISPATCH_COLLECT_COURSE} from "@constants/action-type/course-action-type";
import {COMMIT_CHANGE_IN_SHOPPING_CART} from "@constants/mutation-type/course-mutation-type";

const {mapState} = createNamespacedHelpers('course');

export default {
  name: "CourseIntroduce",
  mixins: [common],
  data() {
    return {
      //显示确认付款弹框
      showPayModel: false,
      okText: "去付款",
      confirmLoading: false,
    }
  },
  methods: {
    canPlayVideo() {
      // 对于免费课程，未登录就能访问
      if (this.isFree) {
        this.$router.push({
          name: 'courseStudy',
          params: {courseId: this.courseInfo.courseId}
        });
      } else if (this.isLoginClick()) {
        // 判断登录之后可以跳转
        this.$router.push({
          name: 'courseStudy',
          params: {courseId: this.courseInfo.courseId}
        });
      }

    },
    collectCourse() {
      if (!this.isLoadCollect && this.isLoginClick()) {
        if (this.isCollect) {
          this.$modal.confirm({
            title: '确认',
            content: '您确定要取消收藏吗？',
            onOk: () => {
              return this.$store.dispatch(DISPATCH_COLLECT_COURSE, {courseId: this.courseInfo.courseId})
            },
            okText: '确定',
            cancelText: '取消'
          })
        } else {
          this.$store.dispatch(DISPATCH_COLLECT_COURSE, {courseId: this.courseInfo.courseId})
        }
      }
    },
    // 显示确认付款弹框
    showModal() {
      // this.modalData = item
      if (this.isLoginClick()) {
        this.showPayModel = true;
      } else {
        this.showPayModel = false;
      }
    },
    // 订单生成中
    handleOk() {
      this.confirmLoading = true;
      this.okText = "订单生成中...";
      createOrder([this.courseInfo.courseId]).then(res => {
        if (res.code === SUCCESS) {
          // todo 跳转到详情界面
          showSuccessMsg("创建成功，即将跳转到支付界面...");
          setTimeout(() => {
            this.$router.push({
              name: 'payDetail',
              params: {
                orderId: res.order.orderId
              }
            })
          }, 300)
        } else if (res.code === COURSE_ALREADY_PAID) {
          showMsg("已自动帮您忽略了您已拥有的课程");
        } else {
          showError('创建订单失败', res.msg);
        }
        this.confirmLoading = true;
      })
    },

    //  加入购物车
    joinShoppingCart() {
      if (this.isLoginClick()) {
        if (!this.isInShoppingCart) {
          this.$store.dispatch({
            type: DISPATCH_ADD_CART,
            courseId: this.courseInfo.courseId
          }).then(res => {
            if (res.code === SUCCESS) {
              // 设置该课程为已加入购物车
              this.$store.commit(COMMIT_CHANGE_IN_SHOPPING_CART, {isInShoppingCart: true})
            }
          })
        } else {
          showMsg("该课程已经在购物车里")
        }
      }
    },

  },
  computed: {
    ...mapState({
      isPaid: 'isPaid',
      isCollect: 'isCollect',
      isInShoppingCart: "isInShoppingCart",
      courseInfo: 'courseInfo',
      isLoadCourse: 'isLoadCourse',
      isLoadCollect: "isLoadCollect",
      score: "score"
    }),
    isDiscount() {
      return this.$func.isTrue(this.courseInfo.isDiscount);
    },
    isFree() {
      return this.$func.isTrue(this.courseInfo.isFree);
    }
  }
}
</script>

<style scoped lang="less">
.now-watch{
  width: 121px;
  height: 40px;
  font-size: 18px;
  border-radius: 24px;
  margin-right: 15px;
}
.vip-free {
  width: 62px !important;
  height: auto !important;
  margin-top: -3px !important;
}

.current-price {
  color: #F32425;
  font-size: 19px;
  font-weight: 600;
}

.mobile-bottom-button {
  display: flex;
  align-items: center;

  img {
    width: 16px;
  }

  > div {
    text-align: center;
    margin-right: 23px;
    font-size: 12px;
    color: #333;
  }
}

.buy-now-button {
  width: 121px;
  height: 40px;
  background: linear-gradient(90deg, #FD952D 0%, #F1534B 100%);
  border-radius: 20px;
  font-weight: 500;
  font-size: 18px;
  margin-right: 15px;
  border: none;
}

.join-shop-car {
  width: 121px;
  height: 40px;
  background: #FFE9E9;
  border-radius: 24px;
  font-size: 18px;
  font-weight: 500;
  color: #F1534B;
  border: none;
}

/deep/ .ant-tag-orange {
  background: linear-gradient(48deg, #FE26B8 0%, #F7283F 23%, #FC3D3F 72%, #FF8D2A 100%) !important;
  border-radius: 3px;
  color: #FFFFFF;
}

.course-introduce-container {
  width: 100%;
  position: relative;
  background: white;
  border-radius: 4px;

  .detail-bg {
    position: absolute;
    top: 0;
    left: calc(50% - 114px);
  }

  .course-introduce-inner {
    padding: 20px;

    img {
      width: 330px;
      height: 220px;
      border-radius: 12px;
    }

    li {
      header {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 30px;
        font-weight: 500;
        color: #333333;
      }

      margin: 10px 0;
      font-size: 24px;


    }

    li:nth-of-type(2) {
      font-size: 14px;
      color: #999999;
    }

    li:nth-of-type(3) {
      height: 70px;
      font-family: PingFangSC-Semibold, PingFang SC;
      //优惠后价格
      & > :nth-child(1) {
        font-size: 26px;
        font-weight: 600;
        color: #F32425;
      }

      & > :nth-child(2) {
        font-weight: 500;
        color: #B7BBC4;
        font-size: 14px;
        text-decoration: line-through;
        margin: 0 10px;
      }
    }

  }

  .collection {
    cursor: pointer;
    width: 110px;
    height: 30px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    float: right;
    color: #999999;
    position: absolute;
    right: 30px;
    top: 30px;

    img {
      width: 18px;
      height: 18px;
      margin-bottom: 4px;
    }
  }

  .collection-active {
    border: 1px solid #ffb200;
    color: #ffb200;
  }
}

.modal {
  p {
    img {
      width: 100%;
    }
  }
}

.mobile-course-introduce-container {
  display: flex;
  align-items: center;
  justify-content: center;

  .mobile-cover {
    padding: 10px;
    border-radius: 6px;
    width: 100%;
    height: auto;

    .image-content {
      display: flex;

      .mobile-course-desc-container {
        .mobile-course-desc-inner {
          h4 {
            width: 100%;
            font-weight: 500;
            color: #333;

          }

          .study-num {
            margin-right: 10px;
            font-size: 12px;
            color: #B7BBC4;
          }
        }
      }
    }

    img {
      width: 40%;
      border-radius: 6px;
      margin-right: 10px;
    }
  }

  .mobile-bottom-action {
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: white;
    padding: 0 20px;
    align-items: center;
    z-index: 100;
    border-top: 1px solid rgba(221, 221, 221, 0.4);
  }
}

.Learning-progress-bar {
  width: 200px;
  float: right;

  dt {
    font-size: 13px;
    color: #00CF8C;
    text-align: right;
  }
}

</style>
